import styles from "./MobileSearchInput.module.scss";

type Props = {
  isShow?: boolean;
  className: string;
};

export const MobileSearchInput = ({ isShow, className }: Props) => {
  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const target = e.target as typeof e.target & {
      term: { value: string };
    };
    const value = target.term.value.toUpperCase();
    window.location.href = `/search/search_results/${value}?sp=${value}`;
  };
  return (
    <div
      className={`${className} ${styles.searchInputWrapper} flex flex-col items-center content-center`}
    >
      <form
        className={`w-full flex items-center relative`}
        onSubmit={handleSubmit}
      >
        <input
          placeholder="Search Here"
          required
          data-position="bottom"
          data-delay="50"
          data-tooltip="TIP: Try Searching for Names, Jobs, Hobbies, Initials, etc."
          name="term"
          data-tooltip-id="75f1b7cf-efa6-9936-2878-55d81b434100"
          type="search"
          id="search"
          className="h-full"
        />
        <input
          type="submit"
          value="play_arrow"
          className={`material-icons flex items-center content-center h-full absolute right-0  ${styles.searchButton}`}
        ></input>
      </form>
      <span className={styles.hintText}>
        Enter your name, initials, team or anything
        <br />
        else to begin browsing registrations.
      </span>
    </div>
  );
};
